import { call, takeEvery, put, select } from 'redux-saga/effects';
import pageActions from 'core/page/actions';
import { wrapPageSagaWithErrorHandler } from '../page/sagas';
import dialogActions from './actions';
import workflowActions from '../workflow/actions';

function* agree({ payload }) {
  const response = yield call(payload.request);
  yield put({ payload: { ...payload, data: response.data }, type: dialogActions.AGREE_SUCCESS });

  if (response.data?.meta?.resources?.autoExportInitiated === 'true') {
    yield put(
      workflowActions.restart({
        appRequestId: payload.id,
        ddaAutoExportRequired: true,
      }),
    );
  }
}

function* sign({ payload }) {
  try {
    const response = yield call(payload.request);
    yield put({ payload: { ...payload, data: response.data }, type: dialogActions.SIGN_SUCCESS });
    if (response.data?.meta?.resources?.autoExportInitiated === 'true') {
      yield put(
        workflowActions.restart({
          appRequestId: payload.id,
          ddaAutoExportRequired: true,
        }),
      );
    }
  } catch (e) {
    const errorMsg =
      e.response?.data?.result?.msgs?.['*'] || 'An error occurred while saving signature';
    yield put(pageActions.saveSignatureError(errorMsg));
  }
}

function* sendCode({ payload }) {
  const { data, fields } = yield select();
  const fieldId = 'appRequest_customer_mfa';
  const maskedValue = fields[fieldId].lookupValues[data[fieldId]]
    .replace('Email Address ', '')
    .replace('Mobile Number ', '');
  const requestData = {
    appRequest_customer_mfa: `${data[fieldId]}-${maskedValue}`,
  };
  const response = yield call(payload.request(requestData));

  yield put({ payload: { data: response.data }, type: dialogActions.SEND_CODE_SUCCESS });
}

export default [
  takeEvery(dialogActions.AGREE, wrapPageSagaWithErrorHandler(agree)),
  takeEvery(dialogActions.SIGN, wrapPageSagaWithErrorHandler(sign)),
  takeEvery(dialogActions.SEND_CODE, wrapPageSagaWithErrorHandler(sendCode)),
];
